import React from 'react'
import { Typography, Paper, Box, LinearProgress, Stack } from '@mui/material'

const StockSummaryCards = ({
  distributionProgress,
  totalReceived,
  totalRemaining,
  maleCount,
  femaleCount,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 1.5, sm: 2, md: 2.5 }}
      sx={{ mb: { xs: 2.5, sm: 3, md: 3.5 } }}>
      {/* Shirt Distribution Progress Card */}
      <Box sx={{ width: { xs: '100%', sm: '50%' }, flex: { sm: '1 1 0' } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            borderRadius: 2,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(18, 18, 18, 1)',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                : '0 2px 8px rgba(0, 0, 0, 0.3)',
            height: '100%',
          }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
              mb: { xs: 2, sm: 2.5, md: 3 },
            }}>
            Shirt Distribution Progress
          </Typography>

          {/* Progress Bar */}
          <LinearProgress
            variant="determinate"
            value={distributionProgress}
            sx={{
              height: { xs: 8, sm: 10, md: 12 },
              borderRadius: 1,
              mb: { xs: 2, sm: 2.5, md: 3 },
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? 'rgba(0, 0, 0, 0.08)'
                  : 'rgba(255, 255, 255, 0.12)',
              '& .MuiLinearProgress-bar': {
                borderRadius: 1,
                backgroundColor: 'primary.main',
              },
            }}
          />

          {/* Labels */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
            <Typography
              variant="body2"
              sx={{
                color: 'text.primary',
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                fontWeight: 500,
              }}>
              Already received: {totalReceived?.toLocaleString() || '0'}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                fontWeight: 500,
              }}>
              Remaining: {totalRemaining?.toLocaleString() || '0'}
            </Typography>
          </Stack>
        </Paper>
      </Box>

      {/* Registered Gender Ratio Card */}
      <Box sx={{ width: { xs: '100%', sm: '50%' }, flex: { sm: '1 1 0' } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            borderRadius: 2,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(18, 18, 18, 1)',
            border: (theme) =>
              `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.12)'}`,
            boxShadow: (theme) =>
              theme.palette.mode === 'light'
                ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                : '0 2px 8px rgba(0, 0, 0, 0.3)',
            height: '100%',
          }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
              mb: { xs: 2, sm: 2.5, md: 3 },
            }}>
            Registered Gender Ratio
          </Typography>

          {/* Gender Numbers */}
          <Stack
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            spacing={{ xs: 2, sm: 3, md: 4 }}>
            {/* Male */}
            <Box sx={{ textAlign: 'center' }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  mb: { xs: 0.5, sm: 0.75, md: 1 },
                }}>
                {maleCount?.toLocaleString() || '0'}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                  fontWeight: 500,
                }}>
                Male
              </Typography>
            </Box>

            {/* Female */}
            <Box sx={{ textAlign: 'center' }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  mb: { xs: 0.5, sm: 0.75, md: 1 },
                }}>
                {femaleCount?.toLocaleString() || '0'}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                  fontWeight: 500,
                }}>
                Female
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Stack>
  )
}

export default StockSummaryCards
